import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useNotification } from '../../contexts/NotificationContext';
import { authFetch } from '../../utils/authFetch';

const NovoPrestServico = () => {    
    const { showNotification } = useNotification();
    const url = "service-provider";
    const navigate = useNavigate();

    const [name, setName] = useState('');
    const [company, setCompany] = useState('');
    const [phone, setPhone] = useState('');
    const [serviceType, setServiceType] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await authFetch(url, {
                method: 'POST',                
                body: JSON.stringify({ name, company, phone, serviceType })
            });

            if (!response.ok) throw new Error('Erro ao criar prestador de serviço');

            showNotification("success", "Prestador cadastrado com sucesso!");
            navigate('/PrestServicos');
        } catch (error) {
            console.error(error);
            showNotification("danger", error.message);
        }
    };

    const handlePhoneChange = (e) => {
        let value = e.target.value.replace(/\D/g, '');

        if (value.length > 11) {
            value = value.slice(0, 11); // Limita a 11 dígitos (incluindo DDD)
        }

        if (value.length <= 10) {
            value = value.replace(/(\d{2})(\d)/, '($1) $2');
            value = value.replace(/(\d{4})(\d)/, '$1-$2');
        } else {
            value = value.replace(/(\d{2})(\d)/, '($1) $2');
            value = value.replace(/(\d{5})(\d)/, '$1-$2');
        }

        setPhone(value);
    };

    return (
        <div className="card">
            <div className="card-body p-3">
                <div className="row">
                    <aside className="column">
                        <h4 className="font-weight-bolder mb-0">Novo Prestador</h4>
                    </aside>
                    <div className="column-responsive column-80">
                        <form onSubmit={handleSubmit}>
                            <fieldset className="col-md-6">
                                <div className="mb-3">
                                    <label>Nome</label>
                                    <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} required />
                                </div>
                                <div className="mb-3">
                                    <label>Empresa</label>
                                    <input type="text" className="form-control" value={company} onChange={(e) => setCompany(e.target.value)} />
                                </div>
                                <div className="mb-3">
                                    <label>Telefone</label>
                                    <input type="text" className="form-control" value={phone} onChange={handlePhoneChange} />
                                </div>
                                <div className="mb-3">
                                    <label>Tipo de Serviço</label>
                                    <input type="text" className="form-control" value={serviceType} onChange={(e) => setServiceType(e.target.value)} />
                                </div>
                                <div className="card-footer" style={{ paddingLeft: "0" }}>
                                    <Link to={'/PrestServicos'} className="btn btn-info btn-sm">Voltar</Link>
                                    <button type="submit" className="btn btn-primary btn-sm mx-1">Salvar</button>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NovoPrestServico;
